let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1ruJB"), load("jkTol"), load("lE3cg")]).then(() => parcelRequire('dp2qz'));